<template lang="html">
  <div
    id="section-authorization"
    class="home-base-unauthorised"
  >
    <div class="home-base__form-wrapper">
      <div class="home-base__form-header">
        <div class="home-base__form-title">
          Will you be the top leader<br> with your monster collection?
          <div class="home-base__before-title-icon">
            <SVGIcon
              :name="'sword'"
              :colors="'180deg, rgb(255 255 255 / 0.15), rgb(255 255 255 / 0)'"
            />
          </div>
        </div>
        <div class="home-base__form-subtitle">
          Play Free
        </div>
      </div>
      <!--<LoginFormNew
        :go-to-tutorial="$props.goToTutorial"
        :default-form="$props.defaultForm"
        :token="token"
      />-->
      <div class="home-base__footer-button">
        <Button
          :ga="'buttonPlay'"
          :type="'without-border orange'"
          :height="'48px'"
          :tag="'a'"
        >
          Play Now
        </Button>
      </div>

    </div>
    <div class="home-base__decor-wrapper">
      <div class="home-base__decor home-base__decor--arena" />
      <div class="home-base__decor home-base__decor--monster" />
      <div class="home-base__decor home-base__decor--coins" />
      <div class="home-base__decor home-base__decor--shine" />
    </div>
  </div>
</template>

<script lang="js">
import {
  gsap,
  TimelineMax,
  // Power2,
} from 'gsap/all';
// import LoginFormNew from './LoginFormNew.vue';
import SVGIcon from '../../baseComponents/ui/SVGIcon.vue';
import Button from '../../baseComponents/ui/Button.vue';

export default {
  name: 'Srccomponentshomehomebaseunauthorisedcontainer',
  components: {
    // LoginFormNew,
    SVGIcon,
    Button,
  },
  props: {
    goToTutorial: {
      type: Function,
      default: () => {},
    },
    defaultForm: {
      type: String,
      default: 'LOGIN_FORM_MAIN',
    },
    token: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      animationController: null,
      // controller: null,
      animationDuration: 0.3,
      elContainer: '.home-base-unauthorised',
      elArena: '.home-base__decor--arena',
      elMonster: '.home-base__decor--monster',
      elCoins: '.home-base__decor--coins',
      elShine: '.home-base__decor--shine',
    };
  },
  computed: {},
  mounted() {
    this.animationController = new TimelineMax();
    this.animateAuthorizationContainer();
  },
  methods: {
    animateAuthorizationContainer() {
      const {
        animationController,
        elArena,
        elCoins,
        elShine,
        elMonster,
      } = this;

      return new Promise((resolve) => {
        animationController.clear();
        animationController.add([
          gsap.fromTo(elArena,
            {
              opacity: 0,
              y: +300,
            }, {
              opacity: 1,
              y: 0,
              duration: 2,
            }),
          gsap.fromTo(elCoins,
            {
              opacity: 0,
              x: -300,
            }, {
              opacity: 1,
              x: 0,
              duration: 2,
            }),
          gsap.fromTo(elShine,
            {
              opacity: 0,
            }, {
              opacity: 0.5,
              duration: 3,
            }),
          gsap.fromTo(elMonster,
            {
              opacity: 0,
              x: +300,
            }, {
              opacity: 1,
              x: 0,
              duration: 2,
              onComplete: () => {
                resolve();
              }
            }),
        ]);
      })
    },
  },
};
</script>

<style lang="scss">
  .home-base-unauthorised {
    display: grid;
    grid-template-columns: 100%;
    min-height: 430px;
    position: relative;
    background: {
      image: url("/assets/images_new/home-base-unauthorised__bg.png");
      size: cover;
      repeat: no-repeat;
      position: center bottom;
    };
    @include for-desktop-up {
      min-height: 770px;
      grid-template-columns: repeat(2, 50%);
    }
    @include for-big-desktop-up {
      min-height: 920px;
    }
  }

  .home-base__form-wrapper {
    @include basic-flex(column, flex-start, center);
    position: relative;
    z-index: 10;
    padding-top: 60px;
    @include for-desktop-up {
      padding-top: 0;
      justify-content: center;
    }
  }

  .home-base__form-title {
    @include site-font(Leksa, 20px, 600);
    line-height: 25px;
    text-align: center;
    color: #FFFFFF;
    position: relative;
    @include for-desktop-up {
      font-size: 36px;
      line-height: 44px;
    }
    @include for-big-desktop-up {
      font-size: 48px;
      line-height: 59px;
    }
  }

  .home-base__before-title-icon {
    @include position(absolute, -20px, 50%);
    transform: translateX(50%);
    width: 104px;
    height: 104px;
    @include for-big-desktop-up {
      width: 104px;
      height: 104px;
    }
  }

  .home-base__form-subtitle {
    @include site-font(Leksa, 36px, 600);
    line-height: 36px;
    text-align: center;
    text-shadow: 0 4px 2px rgba(#000000, 0.5);
    color: #CABDDB;
    @include for-desktop-up {
      font-size: 70px;
      line-height: 100px;
    }
    @include for-big-desktop-up {
      font-size: 100px;
      line-height: 169px;
    }
  }

  .home-base__form-description {
    @include site-font(default, 16px, 400);
    line-height: 19px;
    text-align: center;
    color: #FFFFFF;
    padding: 20px 5px 0;
    @include for-desktop-up {
      font-size: 20px;
      line-height: 38px;
      padding: 0;
    }
    @include for-big-desktop-up {
      font-size: 24px;
      line-height: 38px;
    }
  }

  .home-base__decor-wrapper {
    overflow: hidden;
    @include position(absolute, 0, 0, 0, 0);
    @include for-desktop-up {
      @include position(relative, initial, initial, initial, initial);
    }
  }

  .home-base__decor {
    position: absolute;
    opacity: 0;
  }

  .home-base__decor--arena {
    right: -75px;
    bottom: -105px;
    width: 385px;
    height: 460px;
    background: {
      image: url("/assets/images_new/home-base__decor--arena.png");
      size: contain;
      repeat: no-repeat;
    };
    z-index: 1;
    @include for-desktop-up {
      width: 685px;
      height: 712px;
    }
    @include for-big-desktop-up {
      bottom: -170px;
      width: 988px;
      height: 1031px;
    }
  }

  .home-base__decor--monster {
    right: 0;
    bottom: 75px;
    width: 245px;
    height: 240px;
    background: {
      image: url("/assets/images_new/home-base__decor--monster.png");
      size: contain;
      repeat: no-repeat;
    };
    z-index: 4;
    @include for-desktop-up {
      bottom: 100px;
      width: 545px;
      height: 540px;
    }
    @include for-big-desktop-up {
      bottom: 145px;
      width: 702px;
      height: 696px;
    }
  }

  .home-base__decor--shine {
    top: initial;
    right: -70px;
    bottom: 40px;
    width: 280px;
    height: 280px;
    background: radial-gradient(50% 50% at 50% 50%, #F53D06 0%, rgba(#F53D06, 0) 100%);
    z-index: 2;
    @include for-desktop-up {
      top: 50%;
      right: 50%;
      bottom: initial;
      transform: translate(60%, -50%);
      width: 480px;
      height: 480px;
    }
    @include for-big-desktop-up {
      width: 830px;
      height: 830px;
    }
  }

  .home-base__decor--coins {
    left: 33%;
    top: 60%;
    width: 170px;
    height: 105px;
    background: {
      image: url("/assets/images_new/home-base__decor--coins.png");
      size: contain;
      repeat: no-repeat;
    };
    z-index: 3;
    @include for-desktop-up {
      left: 32%;
      top: 44%;
      width: 253px;
      height: 155px;
    }
    @include for-big-desktop-up {
      width: 345px;
      height: 212px;
    }
  }

  .home-base__footer-button {
    padding-top: 20px;
    .btn-custom-block {
      .btn {
        @include site-font(Leksa, 20px, 500);
      }
    }
  }

</style>
